(function(){
  function init(stage){
    var buttons = stage.querySelectorAll('[data-thr-set]');
    buttons.forEach(function(btn){
      btn.addEventListener('click', function(){
        var state = btn.getAttribute('data-thr-set');
        stage.setAttribute('data-state', state);
        buttons.forEach(function(b){ b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      });
    });
  }
  document.querySelectorAll('[data-thr-toggle]').forEach(init);
})();
